import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import {
  dayoffsSupervisorApi,
  TDayOffSupervisorResponsePaginated,
} from 'app/services/edpApiV1/supervisor/dayoffSupervisor';

interface TInitialState extends TDayOffSupervisorResponsePaginated {
  loading: boolean;
  success: boolean;
  error?: string;
}

const initialState: TInitialState = {
  data: [],
  pagination: { page: 1, size: 10, total: 0 },
  loading: false,
  success: false,
};

export const dayOffSupervisorSlice = createSlice({
  name: 'dayOffSupervisor',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addMatcher(
        dayoffsSupervisorApi.endpoints.dayoffsDeputy.matchFulfilled,
        (state, { payload }: PayloadAction<TDayOffSupervisorResponsePaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsDeputy.matchRejected, () => initialState)
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsDeputy.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        dayoffsSupervisorApi.endpoints.dayoffsActing.matchFulfilled,
        (state, { payload }: PayloadAction<TDayOffSupervisorResponsePaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsActing.matchRejected, () => initialState)
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsActing.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        dayoffsSupervisorApi.endpoints.dayoffsSupervisor.matchFulfilled,
        (state, { payload }: PayloadAction<TDayOffSupervisorResponsePaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsSupervisor.matchRejected, () => initialState)
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsSupervisor.matchPending, state => {
        state.loading = true;
        state.success = false;
      })

      .addMatcher(
        dayoffsSupervisorApi.endpoints.dayoffsCanceledDeputy.matchFulfilled,
        (state, { payload }: PayloadAction<TDayOffSupervisorResponsePaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsCanceledDeputy.matchRejected, () => initialState)
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsCanceledDeputy.matchPending, state => {
        state.loading = true;
        state.success = false;
      })

      .addMatcher(
        dayoffsSupervisorApi.endpoints.dayoffsCanceledActing.matchFulfilled,
        (state, { payload }: PayloadAction<TDayOffSupervisorResponsePaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsCanceledActing.matchRejected, () => initialState)
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsCanceledActing.matchPending, state => {
        state.loading = true;
        state.success = false;
      })
      .addMatcher(
        dayoffsSupervisorApi.endpoints.dayoffsCanceledSupervisor.matchFulfilled,
        (state, { payload }: PayloadAction<TDayOffSupervisorResponsePaginated>) => {
          state.data = payload.data;
          state.pagination = payload.pagination;
          state.loading = false;
          state.success = true;
        },
      )
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsCanceledSupervisor.matchRejected, () => initialState)
      .addMatcher(dayoffsSupervisorApi.endpoints.dayoffsCanceledSupervisor.matchPending, state => {
        state.loading = true;
        state.success = false;
      });
  },
});

const dayOffSupervisor = (state: RootState) => state.entities.supervisor.dayOffSupervisorReducer;
export const getDayOffSupervisor = createSelector(dayOffSupervisor, state => state);

export const actions = dayOffSupervisorSlice.actions;
export const reducer = dayOffSupervisorSlice.reducer;
